import {motion} from 'framer-motion';
import {waLink} from '../data/whatsapp';

const reviews=[
  {quote: 'I walked in nervous and out of shape. Six months later I am lifting weights I never imagined and I actually look forward to training.',name: 'Priya S.',role: 'Member, 2 years'},
  {quote: 'The coaches genuinely care. They remember your name, your goals, and the exact weight you hit last week. It feels personal.',name: 'Rahul M.',role: 'Member, 1 year'},
  {quote: 'Best gym I have ever joined. The community pushes you without making you feel small. I have never been stronger.',name: 'Ananya K.',role: 'Member, 3 years'},
  {quote: 'Clean, professional, and the programming is smart. No gimmicks, just good coaching that actually works.',name: 'Vikram R.',role: 'Member, 6 months'},
];

function Testimonials() {
  return (
    <section className="testimonials-section" id="testimonials">
      <div className="section-head center">
        <span className="eyebrow">In their words</span>
        <h2>Real people.<br /><em>Real progress.</em></h2>
      </div>
      <div className="review-grid">
        {reviews.map((r,i)=> (
          <motion.article
            className="review-card"
            key={r.name}
            initial={{opacity: 0,y: 20}}
            whileInView={{opacity: 1,y: 0}}
            viewport={{once: true}}
            transition={{delay: (i % 2) * 0.12,duration: 0.5}}
          >
            <div className="review-stars">★★★★★</div>
            <p>"{r.quote}"</p>
            <div className="review-author">
              <strong>{r.name}</strong>
              <span>{r.role}</span>
            </div>
          </motion.article>
        ))}
      </div>
      <a
        className="button button-outline center-btn"
        href={waLink('I would like to share my experience with Forge Fitness.')}
        target="_blank"
        rel="noreferrer"
        style={{display: 'flex',width: 'fit-content',maxWidth: 'calc(100% - 2rem)',margin: '40px auto 0'}}
      >
        Share your story ↗
      </a>
    </section>
  );
}

export default Testimonials;
